import React from 'react';
import { useTranslation } from 'react-i18next';

export const QueryResultsTotal = ({ total }: { total: number }) => {
  const { t } = useTranslation();

  if (!total) {
    return null;
  }

  return (
    <div style={{ color: '#6C727F', marginRight: '1em' }}>
      {total === 0 && t('common.noItemsFound', 'No results found')}
      {total !== 0 &&
        t('common.foundResults', '{{count}} results found', {
          count: total,
        })}
    </div>
  );
};
